module.exports = __webpack_public_path__ + "img/mouse.53ce5920.svg";